import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import toast from "react-hot-toast";
import { loginFlow, verifyOtp } from '../redux/slices/authSlice';
import { setQrCode } from '../redux/slices/qrSlice';
import { getT } from '../i18n/translations';



const ErrIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <circle cx="6.5" cy="6.5" r="6" stroke="#e05252" strokeWidth="1.3" />
    <path d="M6.5 3.5v3.5" stroke="#e05252" strokeWidth="1.4" strokeLinecap="round" />
    <circle cx="6.5" cy="9.5" r="0.7" fill="#e05252" />
  </svg>
);


const MobileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4a7c59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="2.5" />
  </svg>
);

const TermsModal = ({ onClose, t }) => (
  <div
    style={{ position: 'fixed', inset: 0, zIndex: 999, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
    onClick={onClose}
  >
    <div
      style={{ backgroundColor: '#fff', borderRadius: '20px 20px 0 0', padding: '24px 20px 32px', width: '100%', maxWidth: '448px', maxHeight: '80vh', overflowY: 'auto' }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <p style={{ fontSize: '15px', fontWeight: '700', color: '#1a2e1a', margin: 0 }}>TERMS &amp; CONDITIONS</p>
        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#5a7a5a', lineHeight: 1, padding: '0 4px' }}>&#10005;</button>
      </div>
      <p style={{ fontSize: '11px', fontWeight: '700', color: '#2d5a2d', marginBottom: '12px', letterSpacing: '0.5px' }}>

      </p>
      {[
        "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ratione id ex quibusdam voluptates nostrum autem harum molestiae eius doloribus atque. Odio voluptates corrupti temporibus officiis veritatis consequatur eligendi. Odit eligendi rerum inventore voluptatum deserunt qui doloremque magni cum soluta nostrum.",
        "Ratione id ex quibusdam voluptates nostrum autem harum molestiae eius doloribus atque. Odio voluptates corrupti temporibus officiis veritatis consequatur eligendi. Odit eligendi rerum inventore voluptatum deserunt qui doloremque magni cum soluta nostrum.",
        "Nostrum autem harum molestiae eius doloribus atque. Odio voluptates corrupti temporibus officiis veritatis consequatur eligendi. Odit eligendi rerum inventore voluptatum deserunt qui doloremque magni cum soluta nostrum.",
        "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ratione id ex quibusdam voluptates nostrum autem harum molestiae eius doloribus atque. Odio voluptates corrupti temporibus officiis veritatis consequatur eligendi. Odit eligendi rerum inventore voluptatum deserunt qui doloremque magni cum soluta nostrum.",
      ].map((text, i) => (
        <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
          <span style={{ fontSize: '12px', fontWeight: '700', color: '#2d5a2d', minWidth: '18px' }}>{i + 1}.</span>
          <p style={{ fontSize: '12px', color: '#3a4e3a', lineHeight: '1.7', margin: 0 }}>{text}</p>
        </div>
      ))}
      <button
        style={{
          width: "100%",
          padding: "15px",
          borderRadius: "16px",
          fontSize: "15px",
          fontWeight: "700",
          color: "#fff",
          border: "none",
          background: "linear-gradient(135deg, #e60012 0%, #b3000f 100%)",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        I Understand
      </button>

    </div>
  </div>
);

const Login = () => {
  const [showTerms, setShowTerms] = useState(false);
  const t = getT();
  const [bg, setBg] = useState('/coke_banner.png');
  const [resendOtpLoader, setResendOtpLoader] = useState(false)

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth < 768) {
        setBg('/coke_banner.png');
      } else {
        setBg('/coke_banner.png');
      }
    };
    updateImage();
    window.addEventListener('resize', updateImage);
    return () => window.removeEventListener('resize', updateImage);
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, isNewUser } = useSelector((state) => state.auth);
  const existingCode = useSelector((state) => state.qr.code);
  const savedCode = localStorage.getItem('qrCode');

  const [step, setStep] = useState('phone');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);
  const [otpError, setOtpError] = useState('');

  useEffect(() => {
    if (!existingCode && savedCode) dispatch(setQrCode(savedCode));
  }, []);

  const handlePhoneSubmit = async () => {
    if (phoneNumber.length !== 10) {
      toast.error(t.invalidMobile);
      return;
    }
    const res = await dispatch(loginFlow(phoneNumber));

    if (res.meta.requestStatus === 'fulfilled') {
      toast.success(t.otpSentTo + ' ' + phoneNumber);
      setStep('otp');
    } else {
      toast.error(res.payload);
    }
  };

  const handleOtpChange = (index, value) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setOtpError('');
    if (value && index < 3) document.getElementById('otp-' + (index + 1))?.focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById('otp-' + (index - 1))?.focus();
    }
  };

  const handleOtpSubmit = async () => {
    const finalOtp = otp.join('');
    if (finalOtp.length !== 4) {
      setOtpError(t.otpError);
      return;
    }

    // localStorage.setItem("isLoggedIn", "true");
    // localStorage.setItem("isCardShow", "true")
    // navigate('/home');

    const res = await dispatch(verifyOtp({ otp: finalOtp, mobile: phoneNumber }));
    if (res.meta.requestStatus === 'fulfilled') {
      navigate(isNewUser ? '/profile-setup' : '/home');
      localStorage.setItem("isCardShow", "true")
    } else {
      setOtpError(t.invalidOtp);
    }
  };

  const handleResendOtp = async () => {
    setResendOtpLoader(true)
    const res = await dispatch(loginFlow(phoneNumber));
    if (res.meta.requestStatus === 'fulfilled') toast.success(t.otpSentTo + ' ' + phoneNumber);
    setResendOtpLoader(false)
  };

  const isSubmitDisabled = loading || phoneNumber.length !== 10 || !termsAccepted;
  const isVerifyDisabled = loading || otp.join('').length !== 4;

  return (
    <React.Fragment>
      {showTerms && (
        <TermsModal onClose={() => setShowTerms(false)} t={t} />
      )}

      <div
        style={{
          fontFamily: "'Poppins', sans-serif",
          backgroundColor: "#fff5f5",
          backgroundImage:
            "radial-gradient(circle, #ffd6d6 1px, transparent 1px)",
          backgroundSize: "22px 22px",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "420px",
            height: "100vh",
            height: "100dvh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* BACKGROUND IMAGE */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: "18px",
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "top center",
              backgroundRepeat: "no-repeat",
              zIndex: 0,
            }}
          />

          {/* RED OVERLAY */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to bottom, rgba(179,0,15,0.45), rgba(0,0,0,0.55))",
              zIndex: 0,
            }}
          />

          {/* CONTENT */}
          <div
            style={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              height: "100%",
              padding: "0 20px",
            }}
          >
            {step === "phone" && (
              <React.Fragment>

                {/* LOGO / TITLE */}
                <div style={{ textAlign: "center", marginTop: "40px" }}>
                  <h1
                    style={{
                      fontSize: "30px",
                      fontWeight: "800",
                      color: "#fff",
                      marginTop: "20px",
                      letterSpacing: "0.5px",
                      textShadow: "0 3px 10px rgba(0,0,0,0.25)",
                    }}
                  >
                    {t.home_welcome}
                  </h1>

                  <p
                    style={{
                      color: "rgba(255,255,255,0.85)",
                      fontSize: "13px",
                      marginTop: "8px",
                    }}
                  >
                  </p>
                </div>

                <div style={{ flex: 0.3 }} />

                {/* LOGIN CARD */}
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "28px",
                    padding: "26px 20px",
                    width: "100%",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.18)",
                    marginBottom: "32px",
                    border: "1px solid #ffe1e1",
                  }}
                >
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "700",
                      color: "#e60012",
                      textTransform: "uppercase",
                      letterSpacing: "0.12em",
                      marginBottom: "8px",
                      marginTop: 0,
                    }}
                  >
                    {t.mobileLabel}
                  </p>

                  {/* MOBILE FIELD */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1.5px solid #ffd6d6",
                      borderRadius: "16px",
                      padding: "13px 14px",
                      gap: "10px",
                      background: "#fff5f5",
                    }}
                  >
                    <MobileIcon />

                    <div
                      style={{
                        width: "1px",
                        height: "20px",
                        backgroundColor: "#ffcaca",
                      }}
                    />

                    <input
                      type="tel"
                      inputMode="numeric"
                      placeholder={t.mobilePlaceholder}
                      value={phoneNumber}
                      maxLength={10}
                      onChange={(e) =>
                        setPhoneNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10)
                        )
                      }
                      style={{
                        flex: 1,
                        background: "transparent",
                        outline: "none",
                        border: "none",
                        fontSize: "15px",
                        color: "#111",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    />
                  </div>

                  {/* TERMS */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "16px",
                      marginBottom: "22px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="terms"
                      checked={termsAccepted}
                      onChange={(e) => setTermsAccepted(e.target.checked)}
                      style={{
                        width: "16px",
                        height: "16px",
                        cursor: "pointer",
                        accentColor: "#e60012",
                      }}
                    />

                    <label
                      htmlFor="terms"
                      style={{
                        fontSize: "13px",
                        color: "#444",
                        cursor: "pointer",
                        lineHeight: "1.5",
                      }}
                    >
                      {t.termsText}{" "}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowTerms(true);
                        }}
                        style={{
                          color: "#e60012",
                          fontWeight: "700",
                          textDecoration: "none",
                        }}
                      >
                        {t.termsLink}
                      </a>
                    </label>
                  </div>

                  {/* SUBMIT BUTTON */}
                  <button
                    disabled={isSubmitDisabled}
                    onClick={handlePhoneSubmit}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      padding: "15px",
                      borderRadius: "16px",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#fff",
                      border: "none",
                      cursor: isSubmitDisabled
                        ? "not-allowed"
                        : "pointer",
                      background: isSubmitDisabled
                        ? "#ffb3b8"
                        : "linear-gradient(135deg, #e60012 0%, #b3000f 100%)",
                      fontFamily: "'Poppins', sans-serif",
                      boxShadow:
                        !isSubmitDisabled
                          ? "0 6px 18px rgba(230,0,18,0.35)"
                          : "none",
                    }}
                  >
                    {loading ? t.sendingOtp : t.submit}

                    {!loading && <span>&#8594;</span>}
                  </button>
                </div>
              </React.Fragment>
            )}

            {step === "otp" && (
              <React.Fragment>
                <div style={{ flex: 0.3 }} />

                {/* OTP CARD */}
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "28px",
                    padding: "26px 20px",
                    width: "100%",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.18)",
                    marginBottom: "32px",
                    border: "1px solid #ffe1e1",
                  }}
                >
                  {/* HEADER */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "16px",
                    }}
                  >
                    <button
                      onClick={() => {
                        setStep("phone");
                        setOtp(["", "", "", ""]);
                        setOtpError("");
                      }}
                      style={{
                        background: "#fff5f5",
                        border: "1px solid #ffd6d6",
                        cursor: "pointer",
                        padding: "8px",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ArrowLeft size={20} color="#e60012" />
                    </button>

                    <h2
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: "700",
                        color: "#b3000f",
                        margin: 0,
                        marginRight: "36px",
                      }}
                    >
                      {t.loginWithOtp}
                    </h2>
                  </div>

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                      color: "#666",
                      marginBottom: "24px",
                      lineHeight: "1.6",
                    }}
                  >
                    {t.otpSentMessage} {phoneNumber}
                  </p>

                  {/* OTP BOXES */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "12px",
                      marginBottom: "20px",
                    }}
                  >
                    {otp.map((v, i) => (
                      <input
                        key={i}
                        id={"otp-" + i}
                        type="text"
                        maxLength={1}
                        inputMode="numeric"
                        value={v}
                        onChange={(e) =>
                          handleOtpChange(
                            i,
                            e.target.value.replace(/\D/g, "")
                          )
                        }
                        onKeyDown={(e) => handleOtpKeyDown(i, e)}
                        style={{
                          width: "58px",
                          height: "58px",
                          borderRadius: "16px",
                          textAlign: "center",
                          fontSize: "24px",
                          fontWeight: "700",
                          color: "#111",
                          outline: "none",
                          border: otpError
                            ? "1.5px solid #f87171"
                            : "1.5px solid #ffd6d6",
                          backgroundColor: otpError
                            ? "#fff1f2"
                            : "#fff5f5",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      />
                    ))}
                  </div>

                  {/* ERROR */}
                  {otpError && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#ef4444",
                        marginBottom: "14px",
                      }}
                    >
                      <ErrIcon /> {otpError}
                    </div>
                  )}

                  {/* VERIFY BUTTON */}
                  <button
                    disabled={isVerifyDisabled}
                    onClick={handleOtpSubmit}
                    style={{
                      width: "100%",
                      padding: "15px",
                      borderRadius: "16px",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#fff",
                      border: "none",
                      cursor: isVerifyDisabled
                        ? "not-allowed"
                        : "pointer",
                      background: isVerifyDisabled
                        ? "#ffb3b8"
                        : "linear-gradient(135deg, #e60012 0%, #b3000f 100%)",
                      fontFamily: "'Poppins', sans-serif",
                      boxShadow:
                        !isVerifyDisabled
                          ? "0 6px 18px rgba(230,0,18,0.35)"
                          : "none",
                    }}
                  >
                    {resendOtpLoader ? t.login : loading ? t.verifying : t.login}
                  </button>

                  {/* RESEND */}
                  <div style={{ textAlign: "center", marginTop: "16px" }}>
                    <button
                      onClick={handleResendOtp}
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#e60012",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {t.resendOtp}
                    </button>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>

          {/* FOOTER */}
          {/* <div
            className="absolute bottom-0 left-0 w-full p-3"
            style={{
              background:
                "linear-gradient(to top, rgba(179,0,15,0.9), rgba(179,0,15,0.65))",
              backdropFilter: "blur(6px)",
            }}
          >
            <p className="w-full text-[10px] tracking-[1.5px] text-white uppercase text-center font-semibold">
              © {new Date().getFullYear()} Consumer Journeys. All Rights Reserved.
            </p>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;

